<p class="sub-form-title no-margin">Search Result</p>
<div> 
    <form [formGroup]="dateForm" class="row row-padding" (submit)="onSubmitDates()">
      <div class="col-2"> 
        <mat-form-field  class="mat-date-pick">
          <mat-label>Plate No.</mat-label>
          <input matInput formControlName="plateNo"/>
          <!-- <mat-error *ngIf="dateForm.get('plateNo').hasError('required')">
             Please enter
             <strong>plate Number</strong> 
           </mat-error>-->
       </mat-form-field>
      </div>
    <div class="col-3">
        <mat-form-field  class="mat-date-pick">
            <mat-label>Start date</mat-label>
            <input matInput (click)="picker.open()" [matDatepicker]="picker" formControlName="startDate">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <!-- <mat-error *ngIf="dateForm.get('startDate').hasError('patternValidation')">
              Please enter date format
            </mat-error> -->
            <!-- <mat-error *ngIf="dateForm.get('startDate').hasError('patternValidation')">
              Special character or space not allowed at the start and min length is 2
            </mat-error> -->
          </mat-form-field>
    </div> 
    <div class="col-3"> 
        <mat-form-field  class="mat-date-pick">
            <mat-label>End date</mat-label>
            <input matInput (click)="picker1.open()" [matDatepicker]="picker1" formControlName="endDate"
            [min]="dateForm.controls['startDate'].value? dateForm.controls['startDate'].value : maxDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <!-- <mat-error *ngIf="dateForm.get('endDate').hasError('patternValidation')">
              Please enter date format
            </mat-error> -->
          </mat-form-field>                     
    </div>
    <div class="col-3">
      <mat-form-field class="mat-date-pick">
          <mat-label>Street</mat-label>
          <mat-select formControlName="street">
            <mat-option [value]="street.id" *ngFor="let street of streets">{{street.street}}</mat-option>
          </mat-select>
        </mat-form-field>
    </div>
    <div class="col-3 display-flex">
        <button mat-button class="button-primary no-top-margins btn-search"  color="vov-ui-primary">Search Enforcement</button>
        <span ><button style="padding: 22px;" type="reset" class="semi-button semi-reset"  color="vov-ui-primary" (click)="reset()">Reset</button></span> 
    </div>
</form>
  </div> 
  <p class="sub-form-title no-margin">Enforcement Table</p>
  <app-spinner *ngIf="showSpinner; else content"></app-spinner>   
  <ng-template #content>
  <div class="box" *ngIf="enforcement.length;"> 
    <div class="export-button">
      <button mat-button  [disabled]="!enforcement.length" (click)="exportAsXLSX()" color="vov-ui-primary"><i class="fa fa-upload" aria-hidden="true"></i>Export CSV</button>
      </div>
    <app-table [tableData]="enforcement"  [tableColumnsNames]="columnNames"></app-table> 
  </div>
  <p *ngIf="enforcement.length == 0">No Data Found</p>       
   </ng-template> 